import { createConfig, config as defaultConfig } from '@gluestack-ui/themed';

const config = createConfig({
  ...defaultConfig.theme,
  tokens: {
    ...defaultConfig.theme.tokens,
    colors: {
      ...defaultConfig.theme.tokens.colors,
    },
    fontSizes: {
      ...defaultConfig.theme.tokens.fontSizes,
    },
    breakpoints: {
      xs: 400,
      ...defaultConfig.theme.tokens.breakpoints,
    },
  },
});

export { config };

type ConfigType = typeof config;

declare module '@gluestack-ui/themed' {
  interface UIConfig extends ConfigType {}
}
